import ExamArrangeMakeup from './src/main';

/* istanbul ignore next */
ExamArrangeMakeup.install = function(Vue) {
  Vue.component(ExamArrangeMakeup.name, ExamArrangeMakeup);
};

export default ExamArrangeMakeup;
